import { component } from 'picoapp'

export default component((node, ctx) => {
    let newsletterSuccess = document.querySelector('.newsletter-signup .form--success');
    new InstagramFeed({
        'username': 'malibucpro',
        'get_data': true,
        'display_profile': false,
        'callback': function(data) {
            data.edge_owner_to_timeline_media.edges.forEach(item => {
                let thumb = item.node.thumbnail_src;
                let url = item.node.display_url;
                let caption = item.node.edge_media_to_caption.edges[0].node.text

                let slide = document.createElement('div');
                slide.className = 'instagram-feed__item';

                let link = document.createElement('a');
                link.href = url;
                link.className = 'instagram-feed__link';
                link.target = '_blank';

                let photo = document.createElement('img');
                photo.src = thumb;
                photo.alt = caption.replace(/\n/g, " ");

                link.appendChild(photo);
                slide.appendChild(link);
                node.appendChild(slide);

            });
            
            let flickityOptions = {
                wrapAround: true,
                pageDots: false,
                freeScroll: true
            };
        
            if ( matchMedia('screen and (min-width: 1400px)').matches ) {
                flickityOptions.groupCells = 2;
            }
        
            const instaFlickity = new Flickity( node, flickityOptions );

            // call resize after the page loads to fix bug with pjax
            setTimeout(function() {
                instaFlickity.resize();
                if (newsletterSuccess) {
                    newsletterSuccess.scrollIntoView();
                }
            }, 500);
        }
    });
    /*
    let flickityOptions = {
        wrapAround: true,
        pageDots: false,
        freeScroll: true
    };

    if ( matchMedia('screen and (min-width: 1400px)').matches ) {
        flickityOptions.groupCells = 2;
    }

    const instaFlickity = new Flickity( node, flickityOptions );

    // call resize after the page loads to fix bug with pjax
    setTimeout(function() {
        instaFlickity.resize();
    }, 500);
*/
})
